/*
 * @Author: lizhigang
 * @Date: 2025-10-22 15:25:29
 * @Company: www.smm.cn
 * @Description: 账号操作
 */
"use client"

import { CloseOutlined } from "@ant-design/icons"
import { AntdRegistry } from "@ant-design/nextjs-registry"
import { useLocale, useTranslations } from "next-intl"
import { useState } from "react"
import { App, ConfigProvider } from "antd"

import { ActionCallbacks, SignInType } from "../../index"
import ForgotPassword from "../forgot"
import Login from "../login"
import Register from "../register"

import "./index.scss"

import { getAntdLocale } from "@repo/shared"

import IconFont from "../../../IconFont"

export interface Props extends ActionCallbacks {
  /**
   * 语言
   */
  language?: string
  /**
   * 弹窗初始化显示的操作(登录、注册、忘记密码)
   */
  action: SignInType
  /**
   * 关闭弹窗
   */
  onClose: () => void
}

const ModalContent = ({ language, action, onClose, onLoginSuccess, onRegisterSuccess, onForgotSuccess }: Props) => {
  const locale = useLocale()
  const t = useTranslations("signInCommon")
  const [actionType, setActionType] = useState<SignInType>(action)
  const antdLocale = getAntdLocale(locale)
  const hookLocale = useLocale()

  const fontFamilyMap: Record<string, string> = {
    th: "var(--font-noto-sans-thai), var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif",
  }
  const fontFamily = fontFamilyMap[locale] ?? "var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif"

  const currentLocale = language || locale || "en"
  const PROFILE_COMPLETE_URL = `${process.env.NEXT_PUBLIC_API_HOST_USER}/${currentLocale}/profile-complete?url=${encodeURIComponent(window.location.href)}`

  return (
    <AntdRegistry layer={false}>
      <ConfigProvider
        locale={antdLocale}
        theme={{
          token: {
            fontFamily,
          },
        }}
      >
        <App message={{ getContainer: () => document.getElementById("action") || document.body }}>
          <div className="modalWrapper">
            <div className="bannerWrapper">
              <IconFont
                className="logo"
                type="icon-SMMlogo-daizimu"
                width={100}
                height={42}
                style={{ fontSize: 100 }}
              />
              <span className="sloganText">{t("slogan")}</span>
            </div>
            <div id="action" className="action">
              {actionType === "forgot" && (
                <IconFont
                  className="backArrow"
                  type="icon-zuojiantou"
                  width={28}
                  height={28}
                  style={{ fontSize: 28, color: "#333" }}
                  onClick={() => setActionType("login")}
                />
              )}
              <div className="actionWrapper">
                <Login
                  language={language}
                  handleSignUp={() => setActionType("register")}
                  handleForgot={() => setActionType("forgot")}
                  onClose={onClose}
                  onLogined={(msg) => onLoginSuccess?.(msg)}
                  style={{ display: actionType === "login" ? "flex" : "none" }}
                />
                <Register
                  language={language}
                  handleSignIn={() => setActionType("login")}
                  onRegistered={(msg) => {
                    onRegisterSuccess?.(msg)
                    location.href = PROFILE_COMPLETE_URL
                  }}
                  onClose={onClose}
                  style={{ display: actionType === "register" ? "block" : "none" }}
                />
                <ForgotPassword
                  language={language}
                  onReseted={(msg) => {
                    onForgotSuccess?.(msg)
                    setActionType("login")
                  }}
                  onClose={onClose}
                  style={{ display: actionType === "forgot" ? "block" : "none" }}
                />
              </div>
              <div className="termsConditions">
                {t("bySigning")} <a>{t("privacyPolicy")}</a> {t("and")} <a>{t("TermsConditions")}</a>
              </div>
            </div>
            <CloseOutlined className="iconClose" onClick={onClose} />
          </div>
        </App>
      </ConfigProvider>
    </AntdRegistry>
  )
}

export default ModalContent
